import { UvMapFeature } from '@kb3d/models/classes/features/uv-map-feature';
import { FeatureGeometryProcessor, ProcessorData } from './base-processor';
import { SubmeshVertexData } from '@kb3d/view/helpers/geometry-helper';
import { UVMapHelper } from '@kb3d/view/helpers/uvmap-helper';

const uvHelper = new UVMapHelper();

export class UvMapGeometryProcessor extends FeatureGeometryProcessor<UvMapFeature> {
    updateMeshGeometry(
        feature: UvMapFeature,
        vertexData: SubmeshVertexData,
        vertexDataChanges: Partial<SubmeshVertexData>,
        dependencyData: ProcessorData<never>,
    ) {
        const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges,dependencyData);

        uvHelper.generateUVMapInPlace(newVertexData, feature);

        return newVertexData;
    }
}
